

import { motion } from 'framer-motion';
import { Code2, Users, HeartHandshake } from 'lucide-react';

export default function Difference() {
  const cards = [
    {
      icon: <Code2 size={32} />,
      title: "FOR DEVELOPERS",
      content: "Get work you can actually start on. No more playing detective."
    },
    {
      icon: <Users size={32} />,
      title: "FOR SUPPORT",
      content: "Clear guidance on what's needed. No guessing, no back-and-forth."
    },
    {
      icon: <HeartHandshake size={32} />,
      title: "FOR EVERYONE",
      content: "Less time clarifying. More time helping each other."
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-primary mb-4">
            What changes when friction disappears
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {cards.map((card, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="p-8 rounded-2xl border border-gray-100 hover:border-blue-100 hover:shadow-lg transition-all duration-300 group"
            >
              <div className="w-16 h-16 bg-blue-50 rounded-xl flex items-center justify-center text-accent mb-6 group-hover:scale-110 transition-transform duration-300">
                {card.icon}
              </div>
              <h3 className="text-sm font-bold text-text-light tracking-wider mb-3">{card.title}</h3>
              <p className="text-xl font-medium text-primary leading-snug">
                {card.content}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
